"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRelatedPagesDataFromJSON = AdminRelatedPagesDataFromJSON;
exports.AdminRelatedPagesDataFromJSONTyped = AdminRelatedPagesDataFromJSONTyped;
exports.AdminRelatedPagesDataToJSON = AdminRelatedPagesDataToJSON;
exports.AdminRelatedPagesDataToJSONTyped = AdminRelatedPagesDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AdminRelatedPagesDataFromJSON(json) {
    return AdminRelatedPagesDataFromJSONTyped(json, false);
}
function AdminRelatedPagesDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
        'payload': !(0, runtime_1.exists)(json, 'payload') ? undefined : (0, _1.AdminRelatedPagesDataPayloadFromJSON)(json['payload']),
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'].map(_1.AdminRelatedPagesFromJSON)),
    };
}
function AdminRelatedPagesDataToJSON(value) {
    return AdminRelatedPagesDataToJSONTyped(value, false);
}
function AdminRelatedPagesDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'totalCount': value.totalCount,
        'payload': (0, _1.AdminRelatedPagesDataPayloadToJSON)(value.payload),
        'items': value.items === undefined ? undefined : (value.items.map(_1.AdminRelatedPagesToJSON)),
    };
}
